import * as React from 'react';
import { useAsyncFn } from 'react-use';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

import { Entity } from './entity';

export interface LouverSelectorRenderProps {
    entityKey: string;
    layoutName: string;
    sizesGridName: string;
}

export interface LouverSelectorProps {
    application: string;
    render?: (props: LouverSelectorRenderProps) => JSX.Element;
}
export function LouverSelector({ application, render }: LouverSelectorProps) {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Louver.SelectionServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Louver.SelectionServiceClient, settings.servicesUrl, 'bff.cygnus.louver.selection'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Louver.SelectionContext());
    React.useEffect(() => {(async () => {
        await serviceClient?.init(context, new Services.Louver.SelectionInitializationParams({
            application
        }));
        await serviceClient?.select(context);
        setContext(new Services.Louver.SelectionContext(context));
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient ]);

    return (
        <React.Fragment>
            {render && ((context.entityKey && context.layoutName) ? render({
                entityKey: context.entityKey,
                layoutName: context.layoutName,
                sizesGridName: context.sizesGridName
            }) : <em>Creating selector entity...</em>)}
        </React.Fragment>
    );
}

export const useLouverSelectorXM = (application: string) => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Louver.SelectionServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Louver.SelectionServiceClient, settings.servicesUrl, 'bff.cygnus.louver.selection'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Louver.SelectionContext());
    React.useEffect(() => {(async () => {
        await serviceClient?.init(context, new Services.Louver.SelectionInitializationParams({
            application
        }));
        await serviceClient?.select(context);
        setContext(new Services.Louver.SelectionContext(context));
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient ]);

    const selectSizes = async () => {
        await serviceClient?.select(context);
    };

    const update = async (updates: Record<string, string>) => {
        const transformedUpdates: Array<Services.Configuration.EntityStateQuestion> = [];
        for (let key in updates) {
            transformedUpdates.push(new Services.Configuration.EntityStateQuestion({
                name: key,
                value: updates[key]
            }));
        }

        await serviceClient?.update(context, transformedUpdates);
    };

    // const selectSizes = async () => {
    //     await serviceClient?.select(context);
    //     selectionCb?.();
    // }

    return [ context, selectSizes, update ] as const;
}